<i18n src="@/locales/models/package_group.yml" lang="yaml"></i18n>

<template>
  <div class="grid grid-cols-1 md:grid-cols-8 gap-x-4">
    <div class="md:col-span-6">
      <label class="label-form">
        {{ $t("model.package_group.producer") }}
      </label>
      <v-select
        v-if="options.length > 1"
        name="producer_or_organization"
        class="mt-1 custom-tailwind-select"
        v-model="producer_or_organization"
        :clearable="false"
        :options="options"
        :disabled="disabled_after_select"
      />
      <div class="content-data mt-1" v-else-if="options.length == 1">
        {{ options[0].label }}
      </div>
    </div>
    <div class="md:col-span-2">
      <label class="label-form">Campo</label>
      <v-select
        v-if="crop_fields_options.length > 1"
        :disabled="!Boolean(producer_or_organization)"
        name="producer_or_organization_crop_field"
        class="mt-1 custom-tailwind-select"
        v-model="crop_field"
        :clearable="false"
        :options="crop_fields_options"
      />
      <div
        class="content-data mt-1"
        v-else-if="crop_fields_options.length == 1"
      >
        {{ crop_fields_options[0].label }}
      </div>
      <div class="content-data mt-1" v-else-if="not_found_crop_fields">
        <danger-badge label="No tiene campos" />
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import Requester from "@/views/packing_house/requesters/production/uniq_final_packing_list/query.js";

export default {
  name: "ProducerOrOrganizationSelect",
  components: { vSelect },
  data() {
    return {
      options: [],
      producer_or_organization: null,
      option_default: null,
      crop_field: null,
      crop_fields_options: [],
      loading_crop_fields: false
    };
  },
  props: {
    packing_house_process_id: { required: true },
    container_id: { required: true },
    producer_id: {},
    organization_id: {},
    crop_field_id: {},
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    disabled_after_select: function () {
      if (this.disabled) {
        return Boolean(this.producer_or_organization);
      }
      return false;
    },
    not_found_crop_fields: function () {
      return (
        this.producer_or_organization &&
        !this.loading_crop_fields &&
        this.crop_fields_options.length == 0
      );
    }
  },
  watch: {
    producer_or_organization: function () {
      this.$emit(
        "update:producer_id",
        this.producer_or_organization.producer_id ?? null
      );
      this.$emit(
        "update:organization_id",
        this.producer_or_organization.organization_id ?? null
      );
      this.fetchCropFields();
    },
    crop_field: function (crop_field) {
      this.$emit("update:crop_field_id", crop_field?.id ?? null);
    }
  },
  methods: {
    loadData: async function () {
      await this.fetchProducersOrganizations();
      this.setDefaultOption();
    },
    setDefaultOption: function () {
      this.option_default = this.options.find(
        option =>
          option.producer_id == this.producer_id &&
          option.organization_id == this.organization_id
      );
      if (this.option_default) {
        this.producer_or_organization = this.option_default;
        this.crop_field = this.crop_field_id;
      }
    },
    fetchProducersOrganizations: async function () {
      const { data } = await Requester.fetchProducersOrganizations(
        this.packing_house_process_id,
        this.container_id
      );
      this.options = data;
      if (this.options.length == 1) {
        this.producer_or_organization = this.options[0];
      }
    },
    fetchCropFields: async function () {
      this.loading_crop_fields = true;
      this.crop_field = {};
      const { data } = await Requester.fetchCropFields(
        this.packing_house_process_id,
        this.container_id,
        this.producer_or_organization?.producer_id ?? "",
        this.producer_or_organization?.organization_id ?? ""
      );

      this.crop_fields_options = data;
      if (this.crop_fields_options.length == 1) {
        this.crop_field = this.crop_fields_options[0];
      }
      this.loading_crop_fields = false;
    }
  },
  created() {
    this.loadData();
  }
};
</script>
